import React from "react";
import Header from "../common/Header";
import TodayTeamTabs from "./TodayTeamTabs";
import AddTeam from "./AddTeam";

const MyTeam = () => {
  return (
    <>
      <div className="bg-light_purple7 rounded-2xl overflow-x-hidden  h-[calc(100vh-32px)]">
        <div className="relative overflow-hidden px-2 xs:px-5 pb-4">
          <div className=" overflow-hidden">
            <Header text="My Team" />
          </div>
          <div className="flex flex-col xl:flex-row">
            <div className="w-full xl:w-[62%] 2xl:w-[60%]">
              <TodayTeamTabs />
            </div>
            <div className="w-full xl:w-[38%] 2xl:w-[40%] pt-5 xl:pt-0 xl:pl-6">
              <AddTeam />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MyTeam;
